import {Component, OnInit} from '@angular/core';
import {PromotionCampaignTypeService} from '../../../services/promotion/promotion-campaign-type.service';
import {PromotionCampaignTypeModel} from '../../../models/promotion-campaign-type.model';

@Component({
  selector: 'kv-promo-campaign-type',
  template: `
    <app-kontable
      id="dt_brand"
      title="{{ 'promotion.campaignTypesSectionTitle' | translate }}"
      [columns]="['id', 'code', 'description', 'check_impl_class']"
      [titles]="['#', 'promotion.code', 'promotion.description', 'promotion.checkImplClass']"
      [source]="campaignTypes"
      [showInfoButton]="true"
      [showRecoverButton]="false"
      [showDetailsButton]="false"
      [showAddButton]="true"
      [showGlobalFilter]="false"
      (onAdd)="showAdd()"
      (onEdit)="showEdit($event)"
      (onRemove)="delete($event)"
      *ngIf="!show">
    </app-kontable>
    <kv-promo-campaign-type-detail
        *ngIf="show"
        (back)="toggleShow()"
        [titlePage]="titlePage"
        [campaignType]="addEditCampaignType"
        (saveCampaignType)="save($event)">
    </kv-promo-campaign-type-detail>
  `
})
export class CampaignTypeComponent implements OnInit{

  campaignTypes: PromotionCampaignTypeModel[];
  addEditCampaignType: PromotionCampaignTypeModel = null;
  show = false;
  titlePage = '';

  constructor(
    private svcCampaignType: PromotionCampaignTypeService
  ) {}

  ngOnInit(): void {
    this.reloadList();
  }

  reloadList() {
    this.campaignTypes = [];
    this.svcCampaignType.list(0, 999999).subscribe( res => {
      this.campaignTypes = res.data;
    });
  }

  showAdd() {
    this.titlePage = 'promotion.addCampaignType';
    this.addEditCampaignType = {code: '', description: '', check_impl_class: ''};
    this.toggleShow();
  }

  delete(item) {
    this.svcCampaignType.delete(item.id).subscribe(() => {
      this.reloadList();
    })
  }

  showEdit(item) {
    this.titlePage = 'promotion.editCampaignType';
    this.addEditCampaignType = item;
    this.toggleShow();
  }

  toggleShow() {
    this.show = !this.show;
  }

  save(item) {
    if (!item.id) {
      /*creazione nuovo tipo di campagna*/
      this.svcCampaignType.create({
        code: item.code,
        description: item.description,
        check_impl_class: item.check_impl_class
      }).subscribe( () => {
        this.refresh();
      });
    } else {
      /*modifica tipo di campagna esistente*/
      this.svcCampaignType.update({
        id: item.id,
        code: item.code,
        description: item.description,
        check_impl_class: item.check_impl_class
      }).subscribe( () => {
        this.refresh();
      });
    }
  }

  refresh() {
    this.addEditCampaignType = null;
    this.titlePage = null;
    this.toggleShow();
    this.reloadList();
  }

}



// WEBPACK FOOTER //
// ./src/app/views/promotion/campaign-type/campaign-type.component.ts